<template>
    <basic-modal @hide="close"
                 v-model="opened"
                 :aria-label="header"
                 role="dialog"
                 size="lg"
    >
        <div slot="header">
            <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
            <h3 class="modal-title">{{ header }}</h3>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="hide-goal-option">
                    <vue-switch-with-label
                            name="hideGoal"
                            :value="hideGoal"
                            :label="hideGoalLabel"
                            @input="val => hideGoal = val"
                            class="hide-goal-switch"
                    ></vue-switch-with-label>
                </div>
                <div class="help-text">
                    <p>You can see the {{ 'Goal'|customTerm }} again by clicking the filter and choosing 'show hidden
                        Goals'.</p>
                    <p class="margin-5-top">You can make the {{ 'Goal'|customTerm }} 'In progress' again by clicking
                        'mark Goal as In
                        Progress'</p>
                </div>
            </div>
        </div>
        <div class="row margin-15-top">
            <div class="col-sm-12 text-center">
                <button class="btn-mm btn-green btn-mm-big" @click="ok">Finish {{ 'Goal'|customTerm }}</button>
            </div>
        </div>
        <div slot="footer">
            <div class="row text-left">
                <div class="col-xs-12 ">
                    <button class="btn btn-mm btn-default save-button" @click="close('back')">
                        <i class="far fa-chevron-left"></i> back
                    </button>
                </div>
            </div>
        </div>
    </basic-modal>
</template>

<script>
    import PopupPromiseMixin from '~/vue/mixins/PopupPromiseMixin';

    export default {
        mixins: [PopupPromiseMixin],
        props: {
            initialHideGoal: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                header: 'Finish Goal',
                hideGoal: this.initialHideGoal
            };
        },
        computed: {
            hideGoalLabel() {
                return `Hide this ${this.$customTerm('Goal')} so other people can't see it.`;
            }
        },
        methods: {
            ok() {
                this.save(this.hideGoal);
            }
        }
    };
</script>

<style scoped lang="scss">
  @import "../../styles/const";

  .hide-goal-option {
    margin-bottom: 15px;
  }

  .help-text {
    margin-top: 10px;
    @media (min-width: $screen-mobile-l-min) {
      font-size: $slight-bigger-font-size;
    }
    color: $black;
  }

  .hide-goal-switch {
    @media (min-width: $screen-mobile-l-min) {
      font-size: $slight-bigger-font-size !important;
    }

  }

  p {
    //text-indent: 10px;

  }
</style>
